<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="sellerName" label="销售方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList" size="mini">查询</el-button>
        <el-button @click="showPayDialog" size="mini" type="warning">批量付款</el-button>
      </el-form-item>
    </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="行号" width="50"></el-table-column>
      <el-table-column prop="orderCode" label="订单编号" header-align="center"
                       align="center" min-width="160" :formatter="companyNameFormatter"></el-table-column>
      <el-table-column prop="sellerName" label="销售方" header-align="center"
                       align="center" min-width="160" :formatter="companyNameFormatter"></el-table-column>
      <el-table-column prop="receiptCode" label="发票号" header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column prop="totalAmount" label="发票金额" header-align="center"
                       align="center" min-width="90"></el-table-column>
      <el-table-column prop="payAmount" label="已付款" header-align="center"
                       align="center" min-width="90">
        <template #default="{ row }">
          <el-button v-if="row.payAmount>0" type="text" v-text="row.payAmount"
                     @click="showPayLogDialog(row)"></el-button>
          <span v-else v-text="row.payAmount"></span>
        </template>
      </el-table-column>
      <el-table-column prop="unPayAmount" label="未付款" header-align="center"
                       align="center" min-width="90"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
    <pay-dialog ref="payDialog" @complete="getDataList"></pay-dialog>
    <pay-log-dialog ref="payLogDialog"></pay-log-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import BigNumber from 'bignumber.js'
import PayDialog from '@/views/modules/fund/pay/pay-dialog'
import PayLogDialog from '@/views/modules/fund/pay/pay-log-dialog'

export default {
  mixins: [mixinViewModule],
  components: { PayDialog, PayLogDialog },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/erp/pay/product',
        getDataListIsPage: true,
      },
      dataForm: {
        sellerName: '',
        receiptCode: '',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    companyNameFormatter (row, column, cellValue, index) {
      if (!cellValue) {
        return ''
      }
      return cellValue.replace('有限公司', '')
    },
    showPayLogDialog (row) {
      this.$refs.payLogDialog.queryForm.receiptCode = row.receiptCode
      this.$refs.payLogDialog.init()
    },
    showPayDialog () {
      if (this.dataListSelections.length === 0) {
        return this.$message.error('请选择发票')
      }
      this.$refs.payDialog.dataList = this.dataListSelections.map(item => {
        return {
          ...item,
          id: '',
          payedAmount: item.payAmount,
          payAmount: item.unPayAmount,
          payType: '',
          payNo: '',
          remark: '',
          payTime: ''
        }
      })
      this.$refs.payDialog.init()
    },
    cellStyleHandler ({ row, rowIndex, column }) {
      if (column.property === 'unPayAmount') {
        let unPayAmount = new BigNumber(row.unPayAmount || 0)
        if (unPayAmount.eq(0)) {
          return {
            color: '#67C23A'
          }
        } else {
          return {
            color: '#F56C6C'
          }
        }
      }
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        let totalAmount = new BigNumber(item.totalAmount)
        item.totalAmount = totalAmount.toFixed(2)
        item.unPayAmount = totalAmount.minus(item.payAmount || 0).toFixed(2)
      })
    },

  }
}
</script>

<style scoped>

</style>
